import { render, staticRenderFns } from "./layout-draw.vue?vue&type=template&id=449fc48c"
import script from "./layout-draw.vue?vue&type=script&lang=js"
export * from "./layout-draw.vue?vue&type=script&lang=js"
import style0 from "./layout-draw.vue?vue&type=style&index=0&id=449fc48c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports